import { genderT } from '@/types'
import { httpClient } from './httpClient'

type InvitationDataResponse = {
  data: {
    doctor: {
      firstName: string
      lastName: string
      gender: genderT
      dateOfBirth: string
    }
    approved: boolean
  }
}

type DeleteDoctorPatientApiCallPayload = {
  patientId: number
}

export async function approveDoctor ({ token }: { token: string }) {
  try {
    let url = import.meta.env.VITE_APPROVE_WITH_TOKEN
    url = url.replace('__token__', token)

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_PATIENT_BASEURL,
      url,
      method: 'POST',
      suppressErrorNotification: true,
      data: {
        token
      }
    })

    return response
  } catch (error) {
    console.error('approveDoctor - Error: ', error)
    throw error
  }
}

export async function getInvitationData ({ token }: { token: string }) {
  try {
    let url = import.meta.env.VITE_GET_INVITATION_DATA
    url = url.replace('__token__', token)

    const response: InvitationDataResponse = await httpClient({
      baseURL: import.meta.env.VITE_API_PATIENT_BASEURL,
      url,
      method: 'GET',
      suppressErrorNotification: true,
      cache: false
    })

    return response?.data
  } catch (error) {
    console.error('getInvitationData - Error: ', error)
    throw error
  }
}

export async function stopManagePatient ({
  patientId
}: DeleteDoctorPatientApiCallPayload) {
  try {
    let url = import.meta.env.VITE_STOP_MANAGE_PATIENT_ENDPOINT
    url = url.replace('__patientId__', patientId)

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'POST'
    })

    return response
  } catch (error) {
    console.error('stopManagePatient - Error: ', error)
    throw error
  }
}
